import { render } from "./SportRegionLovComponent.vue?vue&type=template&id=1882bf3c"
import script from "./SportRegionLovComponent.vue?vue&type=script&lang=js"
export * from "./SportRegionLovComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__